import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_ORIGIN = "https://vashzir.com";

/**
 * Dynamically updates <link rel="canonical"> and <meta property="og:url">
 * per route so that Google can index each page separately.
 *
 * Also allows opting a page out of indexing via the `noindex` prop.
 */
export const SeoHead = ({ noindex = false }) => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.replace(/\/+$/, "") || "/";
    const canonicalUrl = path === "/" ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${path}`;

    // Update canonical link
    let canonicalTag = document.querySelector('link[rel="canonical"]');
    if (!canonicalTag) {
      canonicalTag = document.createElement("link");
      canonicalTag.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalTag);
    }
    canonicalTag.setAttribute("href", canonicalUrl);

    // Update og:url
    let ogUrlTag = document.querySelector('meta[property="og:url"]');
    if (!ogUrlTag) {
      ogUrlTag = document.createElement("meta");
      ogUrlTag.setAttribute("property", "og:url");
      document.head.appendChild(ogUrlTag);
    }
    ogUrlTag.setAttribute("content", canonicalUrl);

    // Handle robots meta (noindex for 404 / unknown pages)
    let robotsTag = document.querySelector('meta[name="robots"]');
    if (!robotsTag) {
      robotsTag = document.createElement("meta");
      robotsTag.setAttribute("name", "robots");
      document.head.appendChild(robotsTag);
    }
    robotsTag.setAttribute("content", noindex ? "noindex, follow" : "index, follow");
  }, [location.pathname, noindex]);

  return null;
};

export default SeoHead;
